import StackService from '../services/stack.services';
import { Stack, StackDetail } from '../types/Stack';
import StackMapper, { STACK_MAP_OPERATION } from '../mappers/stack.mapper';
import { Metadata } from '../utils/HttpClientHandler';

const StackController = class StackController {
    public async getAllStacks(filters = {}): Promise<{ stacks: Stack[]; _metadata: Metadata }> {
        const { data: stacks, _metadata }: { data: Stack[]; _metadata: any } = await StackService.getAllStacks(filters);
        return { stacks, _metadata };
    }

    public async getStackById(
        stackId: number | string,
        mapOperation?: STACK_MAP_OPERATION,
    ): Promise<Stack | StackDetail | any> {
        const stack: Stack = await StackService.getStackById(Number(stackId));
        return mapOperation ? StackMapper[mapOperation](stack) : stack;
    }
};

export default new StackController();
